import React, { useEffect, useRef, useState } from 'react';
// import ModalLogo from '../../../assets/images/modal_logo.png';
import closeIcon from '../../../assets/kudzu-plus-images/Close.png';
import 'animate.css';
import { useSelector } from 'react-redux';
import { appTheme } from '../../../helpers/utils/Utils';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import smiOne_logo from '../../../assets/smi-kudzu-images/smi_kudzu_logo.png'


const Modal = (props) => {
  const { t } = useTranslation();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const signUpkudzuPlusTrue = useSelector(state => state.isSignUpKudzuplusTrue);  
  const appThemeData = appTheme(signUpkudzuPlusTrue)
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);

  const { isOpen, onClose, title, smiOneModalBg, content, subtitle, isLogo,isKudzuPlusBg, modalbg, isClimbg, isIframe, Fullheight, defaultCornerRadius = true, isFooter = false, button1, button2, showBack, onBack} = props
  const modalRef = useRef(null);
  const [isclosed, setIsclosed] = useState(0);
  const [loaded, setLoaded] = useState(0);
  const accessTokenToApi = useSelector((state) => state.accessToken);
  const isSignIn = accessTokenToApi == undefined || accessTokenToApi == null
   const currentpath = useLocation()

  const isiPhoneOriPad = () => /(iphone|ipad)/i.test(navigator.userAgent); 

  useEffect(() => {
  
    const handleOutsideClick = (event) => {
      if (event.target.classList.contains('modal')) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('click', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      // modalRef.current.classList.add('animate__animated', 'animate__fadeInUpBig');
      setIsclosed(2)
      setTimeout(() => {
        setLoaded(1)
      }, 500);
    } else if (modalRef.current) {
      setIsclosed(3)
      modalRef.current.classList.remove('fade-in');
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleClose = () => {
    // modalRef.current.classList.remove('animate__fadeInUpBig');
    // modalRef.current.classList.add('animate__fadeOutDown');
    setIsclosed(1)
    setTimeout(() => {
      onClose();
    }, 500); // Adjust the timeout duration as needed
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      onClose();
    }
  };


  // const modalContainerClasses = `modal-container ${props?.bgColor ? props?.bgColor : isClimbg ? 'bg-climb-modal-bg opacity-50' :  'bg-card'}`;
  const modalContainerClasses = ` modal-container  ${props?.bgColor ? props?.bgColor : isClimbg ? 'bg-climb-modal-bg' : smiOneModalBg ? 'bg-[#ffffff]' : isKudzuPlusBg ? 'bg-[#262B3A]' : props.modalbg ? 'bg-[#FEFAEE]' : 'bg-[var(--modalcard-bg)]'  } ${defaultCornerRadius ? ' sm:rounded-tl-card-tr sm:rounded-br-card-bl ' : isFromSmiOne ? ' sm:rounded-tr-[4rem] sm:rounded-bl-[4rem]'  :' sm:rounded-tr-[4rem] sm:rounded-bl-[4rem]'} md:w-[778px] sm:w-[466px] w-[100%] mx-auto shadow-lg z-50 h-[100vh] sm:h-fit sm:mb-10  ${loaded ? ' overflow-y-auto ' : ''} `;


  return (
    <>
    {isOpen && (
    <div
      className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-[var(--kudzu-card-bg)] bg-opacity-90"
      style={{ zIndex: 200 }}
      onClick={(e) => {
        // Close on backdrop click
        if (e.target === e.currentTarget) {
          handleClose();
        }
      }}
    >
        <div
          className={`absolute sm:pt-[130px] bottom-0 left-1/2 w-full transform -translate-x-1/2 rounded-md ${loaded ? ' overflow-y-auto ' : ''}`}
          // className={`absolute sm:pt-[130px] bottom-0 left-1/2 w-full transform -translate-x-1/2 rounded-md ${loaded ? ' overflow-y-auto ' : ''}`}
          style={{
            position: 'absolute',
            top: isclosed == 2 ? '0px' : '2000px',
            transition: 'top 1s ease-in-out'
          }}
        >
          <div
            ref={modalRef}
            className={modalContainerClasses}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            {/* className={modalContainerClasses} style={{ overflowY: 'auto' }} > */}
            <div className="modal-content text-left" >
              <div className={`modal-body  h-[100%] ${isIframe ? 'flex justify-center' : 'flex justify-center items-center '} sm:my-[60px] md:mt-[110px] mt-[68px] mb-[20%] `}>
                <div className={` ${isIframe ? ' w-[85%] xsm:w-[100%]' : 'md:w-[430px] sm:w-[294px] xsm:w-[260px] w-[320px]'} `}>
                  <div style={{ position: 'relative' }}> {/* Add this line */}
                      {showBack && (
                        <button 
                          type="button"
                          className={`absolute md:top-[-50px] sm:top-[-30px] modal-back text-500 cursor-pointer flex flex-row gap-1 ${isIframe ? 'left-[9%] xsm:left-[9%] sm:left-[5%] md:left-[5%] lg:left-[5%] xl:left-[5%] top-[-68px]' : 'left-[2%] xsm:left-[-18%] sm:left-[-18%] md:left-[-24%] lg:left-[-27%] xl:left-[-25%] top-[-30px]'}`}
                          onClick={handleBack}
                          aria-label={t('back')}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg"
                            className="h-[1.5rem] w-[1.5rem] opacity-[80%]"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="#559C7E"
                            aria-hidden="true"
                          >
                            <path strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2} d="M15 19l-7-7 7-7" />
                          </svg>
                          <span className='text-[16px] text-[#559C7E] font-[600]'>{t('back')}</span>
                        </button>
                      )}
                    <button 
                      type="button"
                      className={`absolute md:top-[-50px] sm:top-[-30px] modal-close text-gray-500 hover:text-gray-800 cursor-pointer ${isIframe ? 'right-[9%] xsm:right-[9%] sm:right-[5%] md:right-[5%] lg:right-[5%] xl:right-[5%] top-[-68px]' : 'right-[2%] xsm:right-[-18%] sm:right-[-18%] md:right-[-24%] lg:right-[-27%] xl:right-[-25%] top-[-30px]'}`}
                      onClick={handleClose}
                      aria-label={t('closeModal') || 'Close dialog'}
                    >
                      {kudzuPlusTrue && currentpath.pathname.toLowerCase() !== "/signup" && currentpath.pathname.toLowerCase() !== "/onboard" ? 
                        <img src={closeIcon} alt='' className='opacity-50' aria-hidden="true" />
                        :
                        <svg xmlns="http://www.w3.org/2000/svg"
                          className="h-[1rem] w-[1rem] opacity-[60%]"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      }
                    </button>
                    {(isLogo != undefined && isLogo) && <img src={ isFromSmiOne ? smiOne_logo : appThemeData.ModalLogo}
                      className={` ${signUpkudzuPlusTrue ? '' : isFromSmiOne ? ' h-[55.43px] md:mb-[47px]' : 'md:w-[130px] sm:w-[106px] w-[111px] sm:h-[32px] h-[33.43px] md:h-[39.15px]'}  mb-[35px] md:mb-[51px]`} alt="Modal Logo" />}

                    <div id="modal-title" className='md:w-[430px] sm:w-[294px] xsm:w-[240px] w-[320px] '>
                      {title}
                      {subtitle}
                    </div>
                    {props?.subHeaderMsg &&
                      <div className='md:w-[430px] sm:w-[294px] xsm:w-[260px] w-[320px] mt-3 mb-5 '>
                        {props.subHeaderMsg}
                      </div>
                    }
                    <div id="modal-description">
                      {content}
                    </div>

                  </div>
                </div>
              </div>
                  {isFooter &&
                    <div className='w-full  hidden sm:flex justify-center items-center p-6 bg-[#30BC89] '>
                      {button1}

                    </div>
                  }

            </div> 
          </div>
        </div>
      {isOpen && isFooter &&
        <div className='w-full fixed bottom-0 left-0 sm:hidden justify-center items-center p-6 bg-[#30BC89] animate__animated animate__fadeInUpBig'>
          {button1}
        </div>
      }
    </div>
  )}
 </>

  );
};

export default Modal;